var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSunrunLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 272.01 66.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0087ff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sunrun-Logo_sunrun-blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,28.55c-7.61-2.21-9.87-3.5-9.87-6.57,0-2.2,1.83-4.11,6.67-4.11A14.39,14.39,0,0,1,39,21.55c.3.31.79.06,1-.12L44.27,17c.25-.24.13-.55-.12-.92-3.31-4.34-9.44-5.75-15.26-5.75-8.83,0-15.63,4-15.63,11.76s5.27,11.34,15.21,14.29c5.7,1.65,8.82,2.94,8.82,6.06s-3.56,4.78-8,4.78c-4.72,0-9-1-12.52-4.72-.17-.23-.66-.12-.91.19l-4.54,5.09a.73.73,0,0,0,.19.79C15.68,53.18,22.18,55,28.73,55c9.21,0,17.12-4,17.12-12.68,0-8.35-5.22-11.17-13.86-13.67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.07,11.07H82.41a.74.74,0,0,0-.74.62V37.43c0,5.57-2,9.13-8.76,9.13-6.38,0-8.71-3.18-8.71-8.89V11.87c0-.31-.25-.8-.68-.8H56a.85.85,0,0,0-.73.8v27c0,10.3,6.62,15.76,17.54,15.76S90.7,49,90.7,38.68v-27a.66.66,0,0,0-.61-.62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.94,10.52c-10.85,0-17.9,5.58-17.9,15.93v27a.67.67,0,0,0,.62.62h7.66a.74.74,0,0,0,.73-.62V27.74c0-5.57,2-9.14,8.77-9.14,6.36,0,8.7,3.2,8.7,8.9V53.31c0,.31.25.8.68.8h7.54a.85.85,0,0,0,.74-.8v-27c0-10.3-6.62-15.75-17.54-15.75"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.63,11.07H207a.74.74,0,0,0-.73.62V37.43c0,5.57-2,9.13-8.77,9.13-6.38,0-8.7-3.18-8.7-8.89V11.87c0-.31-.25-.8-.68-.8h-7.54a.85.85,0,0,0-.74.8v27c0,10.3,6.62,15.76,17.53,15.76s17.9-5.59,17.9-16v-27a.65.65,0,0,0-.61-.62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.5,10.52c-10.84,0-17.89,5.58-17.89,15.93v27a.66.66,0,0,0,.6.62h7.67a.75.75,0,0,0,.74-.62V27.74c0-5.57,2-9.14,8.75-9.14,6.39,0,8.72,3.2,8.72,8.9V53.31c0,.31.24.8.68.8h7.53a.85.85,0,0,0,.75-.8v-27c0-10.3-6.63-15.75-17.55-15.75"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.7,10.61h-.27c-2.14,0-3-.09-3.76-.09-10.86,0-17.9,5.58-17.9,15.93v27a.63.63,0,0,0,.6.61h7.68a.72.72,0,0,0,.72-.61V27.74c0-5.57,2-9.13,8.76-9.13h4.17a1.33,1.33,0,0,0,1.3-1.35V12a1.34,1.34,0,0,0-1.32-1.36h0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunrunLogo);
export default __webpack_public_path__ + "static/media/sunrun-logo.18df99b0cacc82d8cb74b9b4d560d429.svg";
export { ForwardRef as ReactComponent };